/**
 * Get the API base URL without trailing slash
 */
export const getApiUrl = (): string => {
  const url = process.env.REACT_APP_API_URL || '';
  return url.replace(/\/$/, ''); // Remove trailing slash if present
};

/**
 * Get authorization headers
 */
export const getAuthHeaders = (): HeadersInit => {
  const token = localStorage.getItem('idToken');
  return {
    'Content-Type': 'application/json',
    Authorization: token ? `Bearer ${token}` : '',
  };
};
